import { API_URL } from "../config/connect";

export default async function getCategories() {
    try {
        const response = await fetch(`${API_URL}/api/v1/categories`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();
        console.log("Categories API response:", data);

        // API может возвращать { categories: [...] } или массив
        const categoriesArray = Array.isArray(data) ? data : data.categories || [];
        console.log("Categories array:", categoriesArray);

        const getName = (c) => c.name_kz || c.name_ru || c.name || '';
        const uniqueCategories = categoriesArray.filter((category, index, self) =>
            index === self.findIndex((c) => getName(c) === getName(category))
        );

        console.log("Unique categories:", uniqueCategories);
        return uniqueCategories;
    } catch (error) {
        console.error("Error fetching categories:", error);
        throw error;
    }
}